import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou",
  "use": "icon-jiantou-usage",
  "viewBox": "0 0 7.213 9.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.213 9.999\" id=\"icon-jiantou\"><defs></defs><path d=\"M146.661.074l3.392,3.888a.212.212,0,0,1-.159.352h-1.668a.21.21,0,0,0-.21.182c-.125.9-.879,4.907-4.454,5.5a.212.212,0,0,1-.173-.375,4.521,4.521,0,0,0,1.638-3.065,15.377,15.377,0,0,0,.124-2.027.218.218,0,0,0-.212-.217h-1.832a.212.212,0,0,1-.16-.352L146.341.074a.212.212,0,0,1,.32,0Z\" transform=\"translate(-142.893 -0.002)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol